// import { useLocationsSVG } from '../hooks/useLocations';
import { Dispatch, SetStateAction } from 'react';
import { MapType } from '../CommonTypes';
import { useLocationsSVG } from '../hooks/useLocations';

import MapViewerArea from './MapViewerArea';
import ZoomableImage from './ZoomableImage';

export const MapView = ({
  map,
  setCurrentMap,
}: {
  map: MapType;
  setCurrentMap: Dispatch<SetStateAction<MapType | null>>;
}) => {
  const [viewBox, locations] = useLocationsSVG(map.svgurl);
  // const [viewBox, locations] = useLocationsSVG('/svg/Gäddeholm_kartbild_01.svg');

  return (
    <>
      <ZoomableImage src={map.imageurl} alt="MapImage" />

      {locations.length > 0 && (
        <svg className="absolute left-0 top-0" viewBox={`${viewBox}`} preserveAspectRatio="none">
          {locations.map(l => {
            if (l.type === 'view') {
              return (
                <MapViewerArea
                  key={l.id}
                  id={l.ref_id}
                  d={l.coordinates}
                  toolTipPlace={l.tooltipplace}
                  toolTipId={'map-tooltip'}
                  setCurrentMap={setCurrentMap}
                />
              );
            }
          })}
        </svg>
      )}
    </>
  );
};
